import React, { useState } from 'react';
import styles from '../../styles/workshop2026Page.module.css';

interface WorkshopCollapsibleCardProps {
  id?: string;
  title: string;
  subtitle?: string;
  defaultOpen?: boolean;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  className?: string;
  nested?: boolean;
  /** Mount children while collapsed (e.g. so a child can load data for the card title). */
  keepChildrenMounted?: boolean;
  children: React.ReactNode;
}

const WorkshopCollapsibleCard: React.FC<WorkshopCollapsibleCardProps> = ({
  id,
  title,
  subtitle,
  defaultOpen = false,
  open: controlledOpen,
  onOpenChange,
  className,
  nested = false,
  keepChildrenMounted = false,
  children,
}) => {
  const [internalOpen, setInternalOpen] = useState(defaultOpen);
  const isOpen = controlledOpen !== undefined ? controlledOpen : internalOpen;

  const toggle = () => {
    const next = !isOpen;
    if (controlledOpen === undefined) setInternalOpen(next);
    onOpenChange?.(next);
  };

  return (
    <section
      id={id}
      className={`${styles.workshopCard}${nested ? ` ${styles.workshopCardNested}` : ''}${className ? ` ${className}` : ''}`}
    >
      <button
        type="button"
        className={`${styles.workshopCardHeader}${nested ? ` ${styles.workshopCardHeaderNested}` : ''}`}
        onClick={toggle}
        aria-expanded={isOpen}
      >
        <span className={styles.workshopCardHeaderText}>
          <span className={styles.workshopCardTitle}>{title}</span>
          {subtitle && !isOpen && <span className={styles.workshopCardSubtitle}>{subtitle}</span>}
        </span>
        <span
          className={`${styles.workshopCardChevron} ${isOpen ? styles.workshopCardChevronOpen : ''}`}
          aria-hidden
        />
      </button>
      {(isOpen || keepChildrenMounted) && (
        <div
          className={`${styles.workshopCardBody}${nested ? ` ${styles.workshopCardBodyNested}` : ''}`}
          hidden={!isOpen}
        >
          {children}
        </div>
      )}
    </section>
  );
};

export default WorkshopCollapsibleCard;
